import { render, staticRenderFns } from "./investor-freezer.vue?vue&type=template&id=7767c3b4&scoped=true&"
import script from "./investor-freezer.vue?vue&type=script&lang=js&"
export * from "./investor-freezer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7767c3b4",
  null
  
)

export default component.exports